import { useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "./data";

const LINKS = [
  { label: "Philosophy", id: "philosophy", testid: "nav-link-philosophy" },
  { label: "Treatments", id: "treatments", testid: "nav-link-treatments" },
  { label: "Results", id: "results", testid: "nav-link-results" },
  { label: "Stories", id: "testimonials", testid: "nav-link-testimonials" },
  { label: "Contact", id: "contact", testid: "nav-link-contact" },
];

export default function Navbar({ onEnquire }) {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-40 bg-cream/85 backdrop-blur-md border-b border-[#E5DDD0]">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 h-16 flex items-center justify-between">
        <button
          data-testid="nav-brand-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 group"
        >
          <span className="w-10 h-10 rounded-full overflow-hidden border border-[#E5DDD0] bg-cream shadow-sm group-hover:border-clay/60 group-hover:shadow-md transition-all duration-300">
            <img
              src="/logo-emblem.png"
              alt="Luviae Aesthetics emblem"
              className="w-full h-full object-cover"
            />
          </span>
          <span className="flex items-baseline gap-2">
            <span className="font-serif text-2xl font-medium tracking-tight text-ink group-hover:text-clay transition-colors duration-300">
              Luviae
            </span>
            <span className="text-[10px] uppercase tracking-[0.3em] text-ink/50 font-semibold">
              Aesthetics
            </span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => go(l.id)}
              className="text-sm text-ink/70 hover:text-clay transition-colors duration-300 relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-clay after:transition-[width] after:duration-300 hover:after:w-full"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-cta-enquire-button"
            onClick={onEnquire}
            className="hidden sm:inline-flex items-center rounded-full bg-ink text-cream text-sm font-semibold px-5 py-2.5 hover:bg-clay hover:-translate-y-0.5 transition-all duration-300"
          >
            Enquire
          </button>
          <button
            data-testid="nav-mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="md:hidden text-ink p-2"
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E5DDD0] bg-cream px-6 py-4 flex flex-col gap-1">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-${l.testid}`}
              onClick={() => go(l.id)}
              className="text-left py-3 text-base text-ink/80 border-b border-[#E5DDD0]/60 last:border-0"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-nav-cta-enquire-button"
            onClick={() => {
              setOpen(false);
              onEnquire();
            }}
            className="mt-3 rounded-full bg-ink text-cream text-sm font-semibold px-5 py-3"
          >
            Enquire
          </button>
        </div>
      )}
    </header>
  );
}
